// Returns text color based on background color
export default function setTextColorWithBackground({ r, g, b }) {
    const color = Math.round(
        (parseInt(r, 10) * 299 +
            parseInt(g, 10) * 587 +
            parseInt(b, 10) * 114) /
            1000
    )

    return color > 125 ? '#000' : '#fff'
}
